// /Users/pramod/Desktop/school-erp/frontend/src/Parent/components/SubjectList.js

import React from 'react';

const SubjectList = ({ 
  subjects = [], 
  electiveSubjects = [], 
  title = 'Enrolled Subjects',
  onSubjectClick = null // Click handler prop
}) => {
  // Combine all subjects together into a single master list
  const allSubjects = [...subjects, ...electiveSubjects];

  // Simplified tags for parent understanding
  const getTypeBadge = (subject) => {
    if (subject.isLab) return { label: 'Practical / Lab', color: 'bg-blue-50 text-blue-700 border-blue-100' };
    if (subject.isLanguage) return { label: 'Language', color: 'bg-emerald-50 text-emerald-700 border-emerald-100' };
    if (subject.isElective) return { label: 'Chosen Subject', color: 'bg-purple-50 text-purple-700 border-purple-100' };
    return null;
  };

  // Get subject display name with fallback
  const getSubjectName = (subject) => {
    return subject.name || subject.subjectName || 'Unknown Subject';
  };

  // Get subject code with fallback
  const getSubjectCode = (subject) => {
    return subject.code || subject.subjectCode || '—';
  };

  if (allSubjects.length === 0) {
    return (
      <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8 text-center shadow-sm">
        <div className="text-4xl mb-2">📚</div>
        <p className="text-slate-400 text-sm font-medium">No subjects have been assigned yet.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <h3 className="text-base font-bold text-slate-900 tracking-tight">{title}</h3>
        <span className="text-xs font-bold text-slate-500 bg-slate-50 border border-slate-200 px-2.5 py-1 rounded-lg shadow-sm">
          {allSubjects.length} Total
        </span>
      </div>

      {/* Main Grid Layout - Switches to 2-columns on desktop */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {allSubjects.map((subject, index) => {
          const typeBadge = getTypeBadge(subject);
          const subjectName = getSubjectName(subject);
          const subjectCode = getSubjectCode(subject);
          
          return (
            <div
              key={subject.id || subject._id || index}
              onClick={() => onSubjectClick && onSubjectClick(subject)}
              className={`bg-white rounded-2xl p-4 border border-slate-100 shadow-sm transition-all flex items-center justify-between ${
                onSubjectClick 
                  ? 'hover:shadow-md hover:border-slate-200 hover:bg-slate-50/30 cursor-pointer active:scale-[0.98]' 
                  : 'hover:shadow-md hover:border-slate-200'
              }`}
            >
              {/* Subject Info */}
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-10 h-10 rounded-xl bg-indigo-50 border border-indigo-100 flex items-center justify-center flex-shrink-0 text-lg">
                  📘
                </div>
                <div className="min-w-0">
                  <p className="font-bold text-slate-900 text-sm truncate">
                    {subjectName}
                  </p>
                  <p className="text-xs text-slate-400 font-medium truncate mt-0.5">
                    Code: {subjectCode}
                  </p>
                </div>
              </div>

              {/* Type Badge */}
              {typeBadge && (
                <span className={`text-[10px] font-bold px-2.5 py-1 rounded-lg border flex-shrink-0 ml-2 ${typeBadge.color}`}>
                  {typeBadge.label}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SubjectList;